import React from "react";
import styles from './ToggleEye.module.scss'
import cx from "classnames";

type ToggleEyeProps = {
    children?: string | JSX.Element;
    toggleEye: () => void;
    status: boolean;
    classes?: string;
    border?: boolean
    title?: string
};

const ToggleEye: React.FC<ToggleEyeProps> = ({  classes, status, children, toggleEye, border= true ,title }) => {
    return (
        <div title={title} className={cx(styles['zr-eye-wrapper'], classes)} onClick={() => toggleEye()}>
            <div style={{marginRight: children ? '1rem': '0rem'}} className={cx(styles['zr-eye'], !status && styles['zr-slash'], border && styles['zr-eye-border'], (!status && border) ? styles['zr-slash-border'] : '')}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
                    <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12" stroke="#000" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1 12C1 12 5 20 12 20C19 20 23 12 23 12" stroke="#000" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                    <circle cx="12" cy="12" r="3" stroke="#000" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
            {children && <span> {children} </span>}
        </div>
    );
};


export default ToggleEye;
